import { render, staticRenderFns } from "./RegistrationUser.vue?vue&type=template&id=138b783e&scoped=true&"
import script from "./RegistrationUser.vue?vue&type=script&lang=js&"
export * from "./RegistrationUser.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationUser.vue?vue&type=style&index=0&id=138b783e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b783e",
  null
  
)

export default component.exports